import urls, { createSubmissionUrl } from '../constants/urls'
import toast from '../../components/elem/Toast'
import FileSaver from 'file-saver'

const isValidFormType = (formType) => {
    return formType && Object.keys(formType).length
}

// upload
const create = (
    authFetch,
    API_URL,
    history,
    formType,
    agencyCode,
    username
) => {
    authFetch(`${API_URL}/upload/create`, {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers':
                'Access-Control-Allow-Origin, X-Requested-With, Content-Type, Accept',
        },
        body: JSON.stringify({
            AgencyCode: agencyCode,
            UploadUser: username,
            FormType: formType.FormType,
        }),
    })
        .then(async (response) => {
            if (response.ok) {
                return response.json()
            } else {
                const error = await response.text()
                throw new Error(error)
            }
        })
        .then((response) => {
            const submissionId = response.submissionId
            history.push(
                `${createSubmissionUrl(
                    urls.form,
                    formType.Link
                )}/${submissionId}`
            )
        })
        .catch((e) => {
            toast({
                level: 'error',
                message:
                    'Submission: ' +
                    (e.message
                        ? e.message
                        : 'Unable to connect to the server. Please try again later.'),
            })
        })
}

const approve = (
    authFetch,
    API_URL,
    history,
    uploadId,
    comments,
    user,
    after
) => {
    const { name, email } = user.profile
    try {
        const commentsParam = comments ? comments : ''
        authFetch(
            `${API_URL}/upload/approve?uploadId=${uploadId}&comments=${commentsParam}&user=${name}`,
            {
                method: 'PUT',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers':
                        'Access-Control-Allow-Origin, X-Requested-With, Content-Type, Accept',
                },
                body: JSON.stringify(''),
            }
        )
            .then(() => {
                history.push(urls.manageSampleResults)
            })
            .catch((e) =>
                toast({
                    level: 'error',
                    message: `Submission Approval Error: ` + e.message,
                    alert: true,
                })
            )
            .finally(() => {
                after()
            })
    } catch {}
}

const reject = (
    authFetch,
    API_URL,
    history,
    uploadId,
    comments,
    user,
    after
) => {
    try {
        const { name, email } = user.profile
        authFetch(
            `${API_URL}/upload/reject?uploadId=${uploadId}&comments=${comments}&user=${name}`,
            {
                method: 'PUT',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers':
                        'Access-Control-Allow-Origin, X-Requested-With, Content-Type, Accept',
                },
                body: JSON.stringify(''),
            }
        )
            .then(() => {
                history.push(urls.manageSampleResults)
            })
            .catch((e) =>
                toast({
                    level: 'error',
                    message: `Submission Approval Error: ` + e.message,
                    alert: true,
                })
            )
            .finally(() => {
                after()
            })
    } catch {}
}

// submission ui
const getExistingSubmission = (
    authFetch,
    API_URL,
    uploadId,
    formType,
    after
) => {
    authFetch(
        `${API_URL}/upload/${formType.APILink}/uploadData?uploadId=${uploadId}`
    )
        .then(async (response) => {
            if (response.ok) {
                return response.json()
            } else {
                const error = await response.text()
                throw new Error(error)
            }
        })
        .then((response) => {
            after(response.uploadData)
        })
        .catch((e) => {
            toast({
                level: 'error',
                message:
                    'Existing Submission Data: ' +
                    (e.message
                        ? e.message
                        : 'Unable to connect to the server. Please try again later.'),
            })
        })
}

const getUploadChanges = (
    authFetch,
    API_URL,
    uploadId,
    formType,
    after,
    abortController
) => {
    authFetch(
        `${API_URL}/upload/${formType.APILink}/uploadChanges?uploadId=${uploadId}`,
        {
            signal: abortController.signal,
        }
    )
        .then(async (response) => {
            if (response.ok) {
                return response.json()
            } else {
                const error = await response.text()
                throw new Error(error)
            }
        })
        .then((response) => {
            after(response.uploadChanges)
        })
        .catch((e) => {
            if (e.name !== 'AbortError') {
                toast({
                    level: 'error',
                    message:
                        'Existing Submission Data: ' +
                        (e.message
                            ? e.message
                            : 'Unable to connect to the server. Please try again later.'),
                })
            }
        })
}

const POSTFORM = (uploadId, files) => {
    const formData = new FormData()

    for (let i = 0; i < files.length; i++) {
        formData.append('files', files[i])
    }

    formData.append('uploadId', uploadId)

    return {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Access-Control-Allow-Origin': '*',
        },
        body: formData,
    }
}

const uploadAttachments = async (authFetch, API_URL, uploadId, files) => {
    try {
        const response = await authFetch(
            `${API_URL}/upload/attachment`,
            POSTFORM(uploadId, files)
        )
        if (response.ok) {
            toast({
                level: 'info',
                message: 'Attachments uploaded successfully',
                alert: true,
            })
            const data = await response.json()
            const { uploadAttachment } = data
            return uploadAttachment
        } else {
            const error = await response.text()
            throw new Error(error)
        }
    } catch (error) {
        toast({
            level: 'error',
            message: 'Upload Attachments failed',
            alert: true,
        })
        throw new Error(error)
    }
}

const deleteAttachment = async (authFetch, API_URL, uploadAttachmentId) => {
    try {
        const response = await authFetch(
            `${API_URL}/upload/attachment/delete?attachmentId=${uploadAttachmentId}`,
            {
                method: 'DELETE',
            }
        )

        if (response.ok) {
            return
        }
    } catch (error) {
        throw new Error(error)
    }
}
const downloadAttachment = async (
    authFetch,
    API_URL,
    uploadAttachmentId,
    fileName
) => {
    try {
        const response = await authFetch(
            `${API_URL}/upload/attachment/downloadFile?attachmentId=${uploadAttachmentId}`,
            {
                headers: {
                    'Content-Type': 'application/octet-stream',
                },
            }
        )
        const blob = await response.blob() // convert the response to a Blob object
        FileSaver.saveAs(blob, fileName) // save the file using FileSaver.js
    } catch (error) {}
}

const getSubmissionConfig = (
    authFetch,
    API_URL,
    formType,
    after,
    menu,
    fin = null
) => {
    authFetch(`${API_URL}/upload/${formType.APILink}/uploadConfig?menu=${menu}`)
        .then(async (response) => {
            if (response.ok) {
                return await response.json()
            } else {
                const error = await response.text()
                throw new Error(error)
            }
        })
        .then((response) => {
            after(response.uploadConfig)
        })
        .catch((e) => {
            toast({
                level: 'error',
                message:
                    'Submission Config: ' +
                    (e.message
                        ? e.message
                        : 'Unable to connect to the server. Please try again later.'),
            })
        })
        .finally(fin)
}

const getReviewText = (authFetch, API_URL, uploadId, formType, after) => {
    authFetch(`${API_URL}/upload/getReviewText?uploadId=${uploadId}&formType=${formType}`)
        .then(async (response) => {
            if (response.ok) {
                return response.json()
            } else {
                const error = await response.text()
                throw new Error(error)
            }
        })
        .then((response) => {
            after(response.reviewText)
        })
        .catch((e) => {
            toast({
                level: 'error',
                message:
                    'Get Submission Review Text: ' +
                    (e.message
                        ? e.message
                        : 'Unable to connect to the server. Please try again later.'),
            })
        })
}

// edd
const getEDDConfig = (authFetch, API_URL, formType, after) => {
    authFetch(`${API_URL}/upload/${formType.APILink}/eddConfig`)
        .then(async (response) => {
            if (response.ok) {
                return response.json()
            } else {
                const error = await response.text()
                throw new Error(error)
            }
        })
        .then((response) => {
            after(response.config)
        })
        .catch((e) => {
            toast({
                level: 'error',
                message:
                    'EDD Config:' +
                    (e.message ? e.message : 'Unable to fetch EDD config.'),
            })
        })
}

// forms in progress + submitted forms grids
const getTableData = (authFetch, API_URL, setLoading, after) => {
    setLoading(true)
    authFetch(`${API_URL}/upload`)
        .then(async (response) => {
            if (response.ok) {
                return response.json()
            } else {
                const error = await response.text()
                throw new Error(error)
            }
        })
        .then((response) => {
            after(response)
        })
        .catch((e) => {
            toast({
                level: 'error',
                message:
                    'Submissions: ' +
                    (e.message
                        ? e.message
                        : 'Unable to connect to the server. Please try again later.'),
            })
        })
        .finally(() => setLoading(false))
}

const bulkSubmit = (
    action,
    authFetch,
    API_URL,
    uploadIds,
    comments,
    username,
    onError,
    after
) => {
    authFetch(`${API_URL}/upload/bulk${action}`, {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers':
                'Access-Control-Allow-Origin, X-Requested-With, Content-Type, Accept',
        },
        body: JSON.stringify({
            UploadUser: username,
            UploadIds: uploadIds,
            Comments: comments,
        }),
    })
        .then(async (response) => {
            if (response.ok) {
                return response.json()
            } else {
                const error = await response.text()
                throw new Error(error)
            }
        })
        .then((response) => {
            after(response)
        })
        .catch((e) => {
            if (onError) onError(e)
            toast({
                level: 'error',
                message:
                    'Bulk Submission: ' +
                    (e.message
                        ? e.message
                        : 'Unable to connect to the server. Please try again later.'),
                alert: true,
            })
        })
}

// shared
const getAgencies = (authFetch, API_URL, after) => {
    authFetch(`${API_URL}/upload/agencies`)
        .then(async (response) => {
            if (response.ok) {
                return response.json()
            } else {
                const error = await response.text()
                throw new Error(error)
            }
        })
        .then((response) => {
            after(response.agencies)
        })
        .catch((e) => {
            toast({
                level: 'error',
                message:
                    'Submission Agencies: ' +
                    (e.message
                        ? e.message
                        : 'Unable to connect to the server. Please try again later.'),
            })
        })
}

const getFormTypes = (authFetch, API_URL, after) => {
    authFetch(`${API_URL}/upload/formTypes`)
        .then(async (response) => {
            if (response.ok) {
                return response.json()
            } else {
                const error = await response.text()
                throw new Error(error)
            }
        })
        .then((response) => {
            after(response.formTypes)
        })
        .catch((e) => {
            toast({
                level: 'error',
                message:
                    'Submission Form Types: ' +
                    (e.message
                        ? e.message
                        : 'Unable to connect to the server. Please try again later.'),
            })
        })
}

const out = {
    reject,
    approve,
    create,
    uploadAttachments,
    getExistingSubmission,
    getUploadChanges,
    getAgencies,
    getSubmissionConfig,
    getEDDConfig,
    getTableData,
    deleteAttachment,
    bulkSubmit,
    getReviewText,
    getFormTypes,
    isValidFormType,
    downloadAttachment,
}

export default out
